export default "__VITE_ASSET__ef862aea__"